import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef<string>("");

  useEffect(() => {
    // Check if we're navigating between menu sections of the same location
    // Pattern: /{location}/menu/{section}
    const menuSectionPattern = /^\/([^/]+)\/menu\/([^/]+)$/;
    const prevMatch = prevPathname.current.match(menuSectionPattern);
    const currentMatch = pathname.match(menuSectionPattern);

    // If both paths are menu sections for the same location, don't scroll
    if (
      prevMatch &&
      currentMatch &&
      prevMatch[1] === currentMatch[1] // Same location (montreal or delson)
    ) {
      prevPathname.current = pathname;
      return;
    }

    // Otherwise, scroll to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    prevPathname.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
